<template>
  <div class="c-select_wrap">
    <div
      class="form-control c-select range-select"
      @click="menuShown = !menuShown">
      {{ currentModeName }}
    </div>
    <div v-if="menuShown">
      <div
        v-if="menuShown"
        class="c-select_menu date-ranges">
        <div
          v-for="option in options"
          :key="option.value"
          class="c-select_menu_item">
          <a
            href="javascript:void(0)"
            class="c-select_menu_item_link range-link"
            @click="onRangeSelected(option.value)">
            {{ option.label }}
            <svg
              v-if="option.value === rangeMode"
              xmlns="http://www.w3.org/2000/svg"
              class="check-icon svg-icon"
              style="width: 18px; height: 18px; margin-top: 12px; float: right"
              viewBox="0 0 24 24">
              <path
                class="color1"
                d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
            </svg>
          </a>
        </div>
        <div v-if="modeCustom">
          <date-picker
            ref="datePicker"
            v-model="ranges"
            :default-value="new Date()"
            :editable="true"
            :disabled-date="disabledDates"
            value-type="format"
            range
            style="width: 224px"
            @change="onRefreshClicked">
            <template v-slot:footer>
              <div
                v-if="hasRangeErrors"
                class="picker-error">
                期間は3日以上空けてください
              </div>
            </template>
          </date-picker>
          <a
            href="javascript:void(0)"
            style="padding: 2px 4px;"
            @click.prevent="onRefreshClicked">
            <svg
              class="svg-icon"
              style="width: 24px; height: 24px;margin-top: 6.5px;"
              viewBox="0 0 120 124">
              <path
                class="color1"
                d="M16.08,59.26A8,8,0,0,1,0,59.26a59,59,0,0,1,
                97.13-45V8a8,8,0,1,1,16.08,0V33.35a8,8,0,0,1-8,
                8L80.82,43.62a8,8,0,1,1-1.44-15.95l8-.73A43,43,
                0,0,0,16.08,59.26Zm22.77,19.6a8,8,0,0,1,1.44,
                16l-10.08.91A42.95,42.95,0,0,0,102,63.86a8,8,0,
                0,1,16.08,0A59,59,0,0,1,22.3,110v4.18a8,8,0,0,
                1-16.08,0V89.14h0a8,8,0,0,1,7.29-8l25.31-2.3Z" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment-timezone'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ja'

export default {
  name: 'DateRangeSelector',
  components: {
    DatePicker,
  },
  props: {
    value: {
      type: String,
      default: 'last7d',
    },
    options: {
      type: Array,
      default: () => ([
        { value: 'last7d', label: '過去7日間' },
        { value: 'last4w', label: '過去4週間' },
        { value: 'last1y', label: '過去1年間' },
        { value: 'all', label: '全期間' },
        { value: 'custom', label: 'カスタム' },
      ]),
    },
    defaultRangeMode: {
      type: String,
      default: 'last7d',
    },
    defaultRanges: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      rangeMode: 'last7d',
      menuShown: false,
      modeCustom: false,
      ranges: [],
      hasRangeErrors: false,
    }
  },
  computed: {
    currentModeName() {
      if (this.rangeMode === 'custom') {
        const dateFrom = moment(this.ranges[0]).format('MM/DD')
        const dateTo = moment(this.ranges[1]).format('MM/DD')
        return `カスタム (${dateFrom} 〜 ${dateTo})`
      }
      const currentMode = this.options.find(option => option.value === this.rangeMode)
      return currentMode
        ? currentMode.label
        : ''
    },
  },
  watch: {
    defaultRangeMode: {
      handler(value) {
        this.rangeMode = value
      },
      immediate: true,
    },
    defaultRanges: {
      handler(value) {
        this.ranges = value
      },
      immediate: true,
    },
  },
  mounted() {
    this.ranges = [
      moment().add(-32, 'days').format('YYYY-MM-DD'),
      moment().add(-2, 'days').format('YYYY-MM-DD'),
    ]
  },
  methods: {
    onRangeSelected(value) {
      this.modeCustom = false
      this.rangeMode = value
      if (value === 'custom') {
        this.modeCustom = true
        this.$nextTick(() => {
          this.$refs.datePicker.focus()
        })
      } else {
        this.$emit('input', value)
        this.menuShown = false
      }
    },
    disabledDates(date) {
      const maxDate = moment().add(-2, 'days').toDate()
      const minDate = moment('2021-12-01').toDate()

      return date > maxDate || date < minDate
    },
    onRefreshClicked() {
      const [fromDate, toDate] = this.ranges
      const diffDays = moment(toDate).diff(moment(fromDate), 'days')
      if (diffDays < 2) {
        this.modeCustom = true
        this.$nextTick(() => {
          this.$refs.datePicker.focus()
        })
        this.hasRangeErrors = true
        return
      }
      this.hasRangeErrors = false
      this.$emit('input', 'custom')
      this.$emit('change-range', this.ranges)
      this.menuShown = false
    },
  },
}
</script>

<style scoped>
.range-select {
  width: 280px;
  line-height: 2.5;
}
.check-link {
  background: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg>')  no-repeat right center;
  background-size: 16px auto;
  color: $c-color;
}
.date-ranges {
  position: absolute;
  background-color: white;
  width: 100%;
  z-index: 100;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  padding: 8px 12px 5px 12px;
  line-height: 2.5;
}
.range-link {
  display:block;
}
.picker-error {
  color: red;
}
</style>
